export enum TaskSortingProperties {
    DUE_DATE = 'dueDate',
    SECTION_NAME = 'sectionName',
    TASK_NAME = 'taskName',
    ASSIGNED_TO = 'assignedTo',
    TASK_STATE = 'taskState',
    COMPANY_NAME = 'companyName',
}
